import React from 'react';
import { IconBase } from '../Base';
export const IconHamburger = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("path", { d: "M16 15H4", style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeLinecap: "round" }),
        React.createElement("path", { d: "M16 10H4", style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeLinecap: "round" }),
        React.createElement("path", { d: "M16 5H4", style: { stroke: 'var(--icon-color)' }, strokeWidth: "1.5", strokeLinecap: "round" })));
};
//# sourceMappingURL=Hamburger.js.map